import React, { useState } from "react";
import './InfoRight.css'
const InfoRight = () => {
  const [visiblePanel, setVisiblePanel] = useState(null);

  const toggleVisibility = (panel) => {
    setVisiblePanel((prevPanel) => (prevPanel === panel ? null : panel));
  };

  return (
    <div className="container-infoRigth-Content">
      <h2 className="infoRigth-Content-h2">Calculadora de WhatsApp</h2>
      <div className="infoRigth-Content-DivInfo">
        <div className="infoRigth-Content-contentSuperior">
          <p className="infoRigth-Content-contentSuperior-pBase">
            Todo lo que necesitas es una plantilla de mensaje para iniciar un
            chat con tus clientes.
          </p>
          <p className="infoRigth-Content-contentSuperior-p">
            Las tarifas varían en función de la categoría y del país de tus
            clientes.
          </p>
          <p className="infoRigth-Content-contentSuperior-p">
            Las tarifas de WhatsApp Business API se basan en una conversación de
            24 horas entre la empresa y el cliente, aplicando tarifas por todos
            los mensajes intercambiados durante ese periodo de tiempo.
          </p>
          <p className="infoRigth-Content-contentSuperior-p">
            Utiliza la calculadora de precios de WhatsApp de Kommo para estimar
            tus gastos en mensajes.
          </p>
        </div>
        <div className="infoRigth-Content-contentMedio">
          <div className="infoRigth-Content-contentMedio-container">
            <div className="infoRigth-Content-contentMedio-containersvg">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="20"
                height="20"
                viewBox="0 0 20 20"
                fill="none"
              >
                <path
                  d="M0.963088 18.7694C0.784461 18.7694 0.622072 18.7248 0.475923 18.6355C0.329773 18.5462 0.216101 18.4284 0.134907 18.2823C0.0537131 18.1361 0.00905627 17.9778 0.000936856 17.8073C-0.00718256 17.6368 0.0374742 17.4703 0.134907 17.3079L9.14746 1.71861C9.24489 1.55622 9.37075 1.43443 9.52501 1.35324C9.67928 1.27204 9.83761 1.23145 10 1.23145C10.1624 1.23145 10.3207 1.27204 10.475 1.35324C10.6293 1.43443 10.7551 1.55622 10.8525 1.71861L19.8651 17.3079C19.9625 17.4703 20.0072 17.6368 19.9991 17.8073C19.9909 17.9778 19.9463 18.1361 19.8651 18.2823C19.7839 18.4284 19.6702 18.5462 19.5241 18.6355C19.3779 18.7248 19.2155 18.7694 19.0369 18.7694H0.963088ZM2.64381 16.8208H17.3562L10 4.15445L2.64381 16.8208ZM10 15.8464C10.2761 15.8464 10.5075 15.7531 10.6942 15.5663C10.881 15.3796 10.9743 15.1482 10.9743 14.8721C10.9743 14.5961 10.881 14.3646 10.6942 14.1779C10.5075 13.9912 10.2761 13.8978 10 13.8978C9.72394 13.8978 9.49254 13.9912 9.30579 14.1779C9.11904 14.3646 9.02567 14.5961 9.02567 14.8721C9.02567 15.1482 9.11904 15.3796 9.30579 15.5663C9.49254 15.7531 9.72394 15.8464 10 15.8464ZM10 12.9234C10.2761 12.9234 10.5075 12.8301 10.6942 12.6433C10.881 12.4566 10.9743 12.2252 10.9743 11.9491V9.02611C10.9743 8.75005 10.881 8.51865 10.6942 8.3319C10.5075 8.14515 10.2761 8.05178 10 8.05178C9.72394 8.05178 9.49254 8.14515 9.30579 8.3319C9.11904 8.51865 9.02567 8.75005 9.02567 9.02611V11.9491C9.02567 12.2252 9.11904 12.4566 9.30579 12.6433C9.49254 12.8301 9.72394 12.9234 10 12.9234Z"
                  fill="#F9B629"
                ></path>
              </svg>
            </div>
            <div>
              <span className="infoRigth-Content-contentMedio-containerSpan">
                Los precios indicados son fijados por Meta y están sujetos a
                cambios.Consulta las últimas{" "}
              </span>
              <a
                className="infoRigth-Content-contentMedio-containerA"
                href="https://developers.facebook.com/docs/whatsapp/pricing/"
                target="blank"
              >
                actualizaciones de Meta
              </a>
            </div>
          </div>
        </div>
        <div className="infoRigth-Content-contentInferior">
          <div className="infoRigth-Content-contentInferior-container">
            <div className="infoRigth-Content-contentInferior-containerCategoria">
              <div
                className="containerCategoria-title"
                onClick={() => toggleVisibility("marketing")}
              >
                <h3>Marketing</h3>
                <button>
                  {visiblePanel === "marketing" ? (
                    <i className="fa-solid fa-minus"></i>
                  ) : (
                    <i className="fa-solid fa-plus"></i>
                  )}
                </button>
              </div>

              <div
                className={`containerCategoria-info ${
                  visiblePanel === "marketing" ? "show" : ""
                }`}
              >
                <p>
                  Las conversaciones de marketing se relacionan con tu empresa,
                  productos o servicios. Estas incluyen ofertas y promociones,
                  sugerencias de productos relacionados, mensajes de carritos
                  abandonados o cualquier conversación que no califique como de
                  autenticación o utilidad.
                </p>
              </div>
            </div>

            <div className="infoRigth-Content-contentInferior-containerCategoria">
              <div
                className="containerCategoria-title"
                onClick={() => toggleVisibility("utility")}
              >
                <h3>Utilidad</h3>
                <button>
                  {visiblePanel === "utility" ? (
                    <i className="fa-solid fa-minus"></i>
                  ) : (
                    <i className="fa-solid fa-plus"></i>
                  )}
                </button>
              </div>
              <div
                className={`containerCategoria-info ${
                  visiblePanel === "utility" ? "show" : ""
                }`}
              >
                <p>
                  Las conversaciones de utilidad se relacionan directamente con
                  una transacción, lo que incluye notificaciones después de la
                  compra y facturas recurrentes.
                </p>
              </div>
            </div>
            <div className="infoRigth-Content-contentInferior-containerCategoria">
              <div
                className="containerCategoria-title"
                onClick={() => toggleVisibility("authentication")}
              >
                <h3>Autenticación</h3>
                <button>
                  {visiblePanel === "authentication" ? (
                    <i className="fa-solid fa-minus"></i>
                  ) : (
                    <i className="fa-solid fa-plus"></i>
                  )}
                </button>
              </div>
              <div
                className={`containerCategoria-info ${
                  visiblePanel === "authentication" ? "show" : ""
                }`}
              >
                <p>
                  Las conversaciones de autenticación proporcionan a los
                  usuarios códigos de acceso de un solo uso con fines de
                  autenticación. Estos pueden enviarse en cualquier etapa del
                  recorrido del usuario, ya sea durante el registro o la
                  recuperación de la cuenta o ante problemas de integridad.
                </p>
              </div>
            </div>
            <div className="infoRigth-Content-contentInferior-containerCategoria">
              <div
                className="containerCategoria-title"
                onClick={() => toggleVisibility("service")}
              >
                <h3>Servicio</h3>
                <button>
                  {visiblePanel === "service" ? (
                    <i className="fa-solid fa-minus"></i>
                  ) : (
                    <i className="fa-solid fa-plus"></i>
                  )}
                </button>
              </div>
              <div
                className={`containerCategoria-info ${
                  visiblePanel === "service" ? "show" : ""
                }`}
              >
                <p>
                  Las conversaciones de servicio son iniciadas por los usuarios
                  y suelen ser consultas de los clientes. Las empresas pueden
                  responder dentro del intervalo de servicio al cliente de 24
                  horas.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default InfoRight;